module.exports = __webpack_public_path__ + "img/IMG_1699_BlackMatted_MockedUp.90f0c1ba.jpg";